import { render } from "./admin-step.vue?vue&type=template&id=ca4cbb4a&scoped=true&ts=true"
import script from "./admin-step.vue?vue&type=script&lang=ts"
export * from "./admin-step.vue?vue&type=script&lang=ts"

import "./admin-step.vue?vue&type=style&index=0&id=ca4cbb4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4cbb4a"]])

export default __exports__